import * as constants from "./constants";

export const fetchMaterialTypes = (data) => {
  return {
    type: constants.FETCH_MATERIAL_TYPES,
    data,
  };
};

export const fetchBoltTypes = (data) => {
  return {
    type: constants.FETCH_BOLT_TYPES,
    data,
  };
};

export const fetchBoltTypesSuccess = (data) => {
  return {
    type: constants.FETCH_BOLT_TYPES_SUCCESS,
    data: data,
  };
};

export const fetchBoltTypesError = (data) => {
  return {
    type: constants.FETCH_BOLT_TYPES_ERROR,
    data: data,
  };
};

export const fetchMaterialTypesSuccess = (data) => {
  return {
    type: constants.FETCH_MATERIAL_TYPES_SUCCESS,
    data: data,
  };
};

export const fetchMaterialTypesError = (data) => {
  return {
    type: constants.FETCH_MATERIAL_TYPES_ERROR,
    data: data,
  };
};

export const updateMaterialTypes = (data) => {
  return {
    type: constants.UPDATE_MATERIAL_TYPES,
    data: data,
  };
};

export const updateMaterialTypesSuccess = (data) => {
  return {
    type: constants.UPDATE_MATERIAL_TYPES_SUCCESS,
    data: data,
  };
};

export const updateMaterialTypesError = () => {
  return {
    type: constants.UPDATE_MATERIAL_TYPES_ERROR,
  };
};

export const updateMaterialTypesOrder = (data) => {
  return {
    type: constants.UPDATE_MATERIAL_TYPES_ORDER,
    data: data,
  };
};

export const updateMaterialTypesOrderSuccess = (data) => {
  return {
    type: constants.UPDATE_MATERIAL_TYPES_ORDER_SUCCESS,
    data: data,
  };
};

export const updateMaterialTypesOrderError = () => {
  return {
    type: constants.UPDATE_MATERIAL_TYPES_ORDER_ERROR,
  };
};

export const deleteMaterialTypes = (data) => {
  return {
    type: constants.DELETE_MATERIAL_TYPES,
    data: data,
  };
};

export const deleteMaterialTypesSuccess = (data) => {
  return {
    type: constants.DELETE_MATERIAL_TYPES_SUCCESS,
    data: data,
  };
};

export const deleteMaterialTypesError = () => {
  return {
    type: constants.DELETE_MATERIAL_TYPES_ERROR,
  };
};

export const createMaterialTypes = (data, id) => {
  return {
    type: constants.CREATE_MATERIAL_TYPES,
    data: data,
  };
};

export const createMaterialTypesSuccess = (data) => {
  return {
    type: constants.CREATE_MATERIAL_TYPES_SUCCESS,
    data: data,
  };
};

export const createMaterialTypesError = (id) => {
  return {
    type: constants.CREATE_MATERIAL_TYPES_ERROR,
    id,
  };
};

export const isAddingAction = (data) => {
  return {
    type: constants.IS_ADDING_UPDATE,
    data,
  };
};
